export default __webpack_public_path__ + "static/media/Software-Faturacao-Bancos.4a9e9d22.png";